import { Pipe, PipeTransform } from '@angular/core';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber',
  standalone: true,
  pure: true
})
export class PhoneNumberPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    defaultCountry: CountryCode = 'CI'
  ): string {
    if (!value) return '-';

    try {
      const phoneNumber = parsePhoneNumberFromString(value, defaultCountry);
      return phoneNumber ? phoneNumber.formatInternational() : value;
    } catch (e) {
      return value;
    }
  }
}
